/* eslint-disable react/button-has-type */
import React, { useContext } from 'react';
import RequisitionContext from '../../../../../../../context/shared/requisitions/RequsitionContext';
import { NOC, RESEARCH_AND_DEVELOPMENT } from '../../../../../../../utils/config';

const NocFilters = () => {
  const { department, onChange, getRequsitionsByDepartment } = useContext(RequisitionContext);
  const submit = () => department.length > 0;
  return (
    <p className="fliter copy-font d-flex mr-auto">
      <small className="mt-2 text-nowrap" style={{ paddingLeft: '8%' }}>
        Filter By:
      </small>
      <span>
        <select className="form-control" name="department" onChange={onChange}>
          <option>Select Departments</option>
          <option value={NOC}>NOC</option>
          <option value={RESEARCH_AND_DEVELOPMENT}>R&D</option>
        </select>
      </span>
      <button
        onClick={() => getRequsitionsByDepartment(department)}
        className="btn btn-green copy-font my-1"
        disabled={!submit()}
      >
        Search Requisition
      </button>
    </p>
  );
};

export default NocFilters;
